import throttle from 'lodash-es/throttle';
import $ from 'jquery';

export default function init () {
    resize_circle_text();
    $(window).on('resize', resize_circle_text);
}

function resize_circle_text() {
    (throttle(function () {
        var circles = $('.wp-block-sitra-timeline-item__circle');

        circles.each(function () {
            var inner_span = $(this).find('span');
            var height = $(this).height() - 20;
            var width = $(this).width() - 20;
            var inner_font_size = parseInt(inner_span.css('font-size'));

            while (inner_span.outerHeight(true) > height || inner_span.outerWidth(true) > width) {
                console.log(inner_font_size, inner_span.outerHeight(true), height);

                inner_span.css('font-size', --inner_font_size + 'px');
            }
        });
    }, 500))();
}
